module.exports = __webpack_public_path__ + "img/Hair-direction2-@2x.2e73762f.jpg";